/**
 * This files contains non-react functions which support searchresultsfacet.js
 *
 * See also: searchresultsfacet_utils.test.js
 */

/**
 * Helper function to return a Solr list facet count as an object.
 * For example:
 *  ["false",123,"true",14]   =>   {false: 123, true: 14}
 *
 * @param facetCountAsList (The face count as a list, raw solar response)
 * @return Object respresentation of that list. If the list is an odd number
 * of items, returns undefined.
 */
export function getSolrListFacetCountAsObject(facetCountAsList) {
    if(!facetCountAsList) {
        return undefined;
    }
    if (facetCountAsList.length % 2 !== 0) {
        return undefined;
    }

    let lastKey = null;
    let facetCountAsObject = {};

    for (var i = 0; i < facetCountAsList.length; i++) {
        if (i % 2 === 0) {
            lastKey = facetCountAsList[i];
        } else {
            facetCountAsObject[lastKey] = facetCountAsList[i];
        }
    }

    return facetCountAsObject;
}


/**
 * Filters out non-zero facet entries only for specified facet fields.
 * Leaves all other fields untouched
 *
 * @param facetFields Object The full facet_fields object from Solr (or similar).
 * @param fields StringArray Array of facet field names to filter, e.g. ["eras", "cadence_cat", "mission_facet_cs"].
 *
 * @returns Object - An object with the same keys, but only non-zero entries.
 */
export function filterNonZeroFacets(facetFields, fields = []) {
    const result = {};

    for (const [field, list] of Object.entries(facetFields)) {
        // If not a targeted field or not an array, keep as-is
        if (!fields.includes(field) || !Array.isArray(list)) {
        result[field] = list;
        continue;
        }

        // Otherwise, filter out zero-counts
        const filtered = [];
        for (let i = 0; i < list.length; i += 2) {
            const key = list[i];
            const count = list[i + 1];
            if (count > 0) {
            filtered.push(key, count);
            }
        }

        result[field] = filtered;
    }

  return result;
}
